export default __webpack_public_path__ + "static/smbBanner-b742d91029ca665e3424f0f873f4b086.png";